import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const homepage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { HomePage } = await import(/* webpackChunkName: "Login" */ '../../../components/pages/private/HomePage')
      return {
        default: HomePage,
      }
    })}
    exact
    key={paths.homepage}
    path={paths.homepage}
  />,
]
